import React from 'react';
import { Layout } from 'antd';
import Header from './Header';

const { Content, Footer } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* 헤더 (상단바) */}
      <Header />

      {/* 콘텐츠 영역 */}
      <Content style={{
        padding: '24px 0',
        background: '#f0f2f5'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          {children}
        </div>
      </Content>

      {/* 푸터 */}
      <Footer style={{ textAlign: 'center', background: '#fff' }}>
        ACG ERP ©{new Date().getFullYear()} Created by INSAHR
      </Footer>
    </Layout>
  );
};

export default MainLayout;
